import React, { useEffect, useState } from "react";
import {
  Modal,
  Tabs,
  Form,
  Input,
  DatePicker,
  Select,
  Card,
  Space,
  Button,
  InputNumber,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addPaymentRecordAPI,
  GetInvoicePaymentsByInvoiceIdApi,
  GetInvoicePaymentsByWorkOrderIdApi,
} from "../InvoicesAPI";
import PaymentTypeEnum from "features/Enums/PaymentTypeEnum";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { use } from "react";

function RecordPayment(props) {
  const [form] = Form.useForm();
  const [refundForm] = Form.useForm();
  const { Option } = Select;
  const intl = useIntl();
  const dispatch = useDispatch();
  const { workOrderId, invoiceId } = useParams();
  const [activeTab, setActiveTab] = useState("1");
  const [amount, setAmount] = useState(0);
  const invoiceData = useSelector((state) => state.invoices.invoiceDetails);
  const workOrderData = useSelector((state) => state.clients.workOrderDetails);
  const invoicePayments = useSelector(
    (state) => state.invoices.invoicePayments
  );
  const [outstandingAmount, setOutstandingAmount] = useState(0);
  const [isRecordPaymentModalVisible, setIsRecordPaymentModalVisible] =
    useState(false);

  const handleRecordPaymentOk = async () => {
    try {
      let values;
      let payload;

      if (activeTab === "1") {
        // Payment
        values = await form.validateFields(); // will throw if invalid
        payload = {
          ...values,
          PaymentTypeId: props?.isDeposit
            ? PaymentTypeEnum.Deposit.id
            : PaymentTypeEnum.Payment.id,
          //PaymentDate: dayjs(values.expiryDate).format("YYYY-MM-DD"),
          PaymentDate: values.Date.format("YYYY-MM-DD"),
          WorkOrderId: workOrderId,
          InvoiceId: invoiceId,
        };
      } else if (activeTab === "2") {
        // Refund
        values = await refundForm.validateFields();
        payload = {
          ...values,
          PaymentTypeId: PaymentTypeEnum.Refund.id,
          PaymentDate: values.Date.format("YYYY-MM-DD"),
          WorkOrderId: workOrderId,
          InvoiceId: invoiceId,
        };
      }

      // Dispatch API call safely
      try {
        await dispatch(addPaymentRecordAPI(payload));
        if (invoiceId) {
          dispatch(GetInvoicePaymentsByInvoiceIdApi(invoiceId));
        } else {
          dispatch(GetInvoicePaymentsByWorkOrderIdApi(workOrderId));
        }
        setIsRecordPaymentModalVisible(false);
        props.close();
      } catch (apiError) {
        console.error("API Error:", apiError);
      }
    } catch (validationError) {
      // Handle AntD validation errors
      console.error("Validation Error:", validationError);
      // Optionally show a message to the user
    }
  };

  const handleRecordPaymentCancel = () => {
    setIsRecordPaymentModalVisible(false);
    props.close();
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  useEffect(() => {
    setIsRecordPaymentModalVisible(props.open);
  }, []);
  useEffect(() => {
    if (invoicePayments) {
      const outstanding =
        invoiceData.finalInvoicingAmount - invoicePayments.item2;
      setOutstandingAmount(outstanding);
    }
  }, [invoicePayments]);
  return (
    <Modal
      title={<FormattedMessage id="Invoice.RecordPayment" />}
      open={isRecordPaymentModalVisible}
      //onOk={handleRecordPaymentOk}
      onCancel={handleRecordPaymentCancel}
      footer={null}
    >
      <Tabs
        defaultActiveKey="1"
        centered
        onChange={handleTabChange}
        className="mt-10"
      >
        <Tabs.Item
          tab={
            props?.isDeposit ? (
              <FormattedMessage id="Record.LogDepositAmount" />
            ) : (
              <FormattedMessage id="Record.LogRecievedAmount" />
            )
          }
          key="1"
        >
          <Form
            layout="horizontal"
            className="viewinvoice-newitem"
            form={form}
            labelCol={{ flex: "0 0 50%" }}
            wrapperCol={{ flex: "0 0 50%" }}
            labelAlign="left"
            colon={false}
          >
            <Card className="clientview-new">
              {!props?.isDeposit && (
                <Form.Item
                  label={<FormattedMessage id="Record.InvoiceAmount" />}
                  name="invoiceAmount"
                >
                  <text>{invoiceData?.finalInvoicingAmount || 0}</text>
                </Form.Item>
              )}
              <Form.Item
                label={
                  !props?.isDeposit ? (
                    <FormattedMessage id="Invoice.OutstandingAmount" />
                  ) : (
                    <FormattedMessage id="WorkOrderDetails.WOAmount" />
                  )
                }
                name="outstanding"
              >
                <text>
                  {!props?.isDeposit
                    ? outstandingAmount?.toFixed(2)
                    : workOrderData?.grandTotal?.toFixed(2)}
                </text>
              </Form.Item>

              <Form.Item
                label={<FormattedMessage id="Invoice.RecordAmount" />}
                name="amountReceived"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Record.error.PleaseEnterAmount",
                    }),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  placeholder={intl.formatMessage({
                    id: "Record.PlaceHolder.EnterAmount",
                  })}
                  onChange={(val) => setAmount(val)}
                />
              </Form.Item>

              {/* {!props?.isDeposit && (
                <Form.Item label="New outstanding amount" name="newOutstanding">
                  <Input disabled />
                </Form.Item>
              )} */}
              <p style={{ color: "red" }}>
                {amount > outstandingAmount && (
                  <FormattedMessage id="Invoice.Theamountenteredexceedstheoutstandingamount" />
                )}
              </p>
            </Card>

            <Card className="clientview-new mt-10">
              <Form.Item
                label={<FormattedMessage id="Invoice.PaymentDate" />}
                name="Date"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Record.error.PleaseSelectDate",
                    }),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.PaidInto" />}
                name="paidInto"
              >
                <Select
                  placeholder={intl.formatMessage({
                    id: "Record.PlaceHolder.PleaseSelect",
                  })}
                >
                  <Option value="bank">
                    <FormattedMessage id="Invoice.Bank" />
                  </Option>
                  <Option value="cash">
                    <FormattedMessage id="Invoice.Cash" />
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.Method" />}
                name="method"
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "Record.PlaceHolder.EnterMethod",
                  })}
                />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.Reference" />}
                name="reference"
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "Invoice.Reference",
                  })}
                />
              </Form.Item>
            </Card>
            <div
              className="mt-15"
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <Space>
                <Button key="cancel" onClick={handleRecordPaymentCancel}>
                  <FormattedMessage id="Common.Cancel" />
                </Button>

                <Button
                  key="submit"
                  type="primary"
                  onClick={handleRecordPaymentOk}
                  style={{ background: "#1e9e5e" }}
                >
                  <FormattedMessage id="Record.Record" /> ${amount || "0.00"}
                </Button>
              </Space>
            </div>
          </Form>
        </Tabs.Item>
        <Tabs.Item
          tab={<FormattedMessage id="Record.RefundPayment" />}
          key="2"
          disabled={props.isDeposit}
        >
          <Form
            form={refundForm}
            layout="horizontal"
            className="viewinvoice-newitem"
            labelCol={{ flex: "0 0 40%" }}
            wrapperCol={{ flex: "0 0 60%" }}
            labelAlign="left"
            colon={false}
            name="refundAmountForm"
          >
            <Card className="clientview-new">
              <Form.Item
                label={<FormattedMessage id="Record.RefundAmount" />}
                name="amountReceived"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Record.error.PleaseEnterRefundAmount",
                    }),
                  },
                  {
                    type: "number",
                    min: 0.01,
                    message: intl.formatMessage({
                      id: "Record.error.AmountMustBeGreaterThanZero",
                    }),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  prefix="$"
                  placeholder={intl.formatMessage({
                    id: "Record.EnterRefundAmount",
                  })}
                  min={0.01}
                  step={0.01}
                />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Record.PaymentDate" />}
                name="Date"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Record.error.PleaseSelectDate",
                    }),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.PaidInto" />}
                name="paidInto"
              >
                <Select placeholder="Please select">
                  <Option value="bank">
                    <FormattedMessage id="Invoice.Bank" />
                  </Option>
                  <Option value="cash">
                    <FormattedMessage id="Invoice.Cash" />
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.Method" />}
                name="method"
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "Record.PlaceHolder.EnterMethod",
                  })}
                />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.Reference" />}
                name="reference"
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "Invoice.Reference",
                  })}
                />
              </Form.Item>
              <Form.Item
                label={<FormattedMessage id="Invoice.RefundNotes" />}
                name="notes"
                rules={[
                  {
                    max: 250,
                    message: intl.formatMessage({
                      id: "Record.error.Max250Characters",
                    }),
                  },
                ]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder={intl.formatMessage({
                    id: "Invoice.ReasonForRefundOptional",
                  })}
                />
              </Form.Item>
            </Card>
            <div
              className="mt-15"
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <Space>
                <Button key="cancel" onClick={handleRecordPaymentCancel}>
                  <FormattedMessage id="Common.Cancel" />
                </Button>

                <Button
                  key="submit"
                  type="primary"
                  onClick={handleRecordPaymentOk}
                  style={{ background: "#1e9e5e" }}
                >
                  <FormattedMessage id="Record.Refund" />
                </Button>
              </Space>
            </div>
          </Form>
        </Tabs.Item>
      </Tabs>
    </Modal>
  );
}

export default RecordPayment;
